// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blocking-window__contact-form {
  border-radius: 8px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.04);
  background: var(--secondary-color);
}
.blocking-window__contact-form .contact-form__container {
  background-color: var(--secondary-color);
}

@media only screen and (min-device-width: 320px) {
  .blocking-container {
    max-width: calc(100vw - 8.8%);
  }
  .blocking-window__contact-form {
    padding: 16px;
  }
  .blocking-window__contact-form .contact-form__container-header {
    font-size: 24px;
    letter-spacing: 0.96px;
  }
  .blocking-window__contact-form .contact-form__info-text {
    font-size: 16px;
    letter-spacing: 0.48px;
  }
  .blocking-window__contact-form .contact-form__info-text {
    margin-bottom: 20px;
  }
  .blocking-window__contact-form .contact-form__content {
    gap: 12px;
  }
}
@media only screen and (min-device-width: 768px) {
  .blocking-container {
    max-width: 552px;
  }
  .blocking-window__contact-form {
    padding: 25px 36px 36px 36px;
  }
  .blocking-window__contact-form .contact-form__container-header {
    font-size: 32px;
    letter-spacing: 1.28px;
  }
  .blocking-window__contact-form .contact-form__info-text {
    font-size: 18px;
    letter-spacing: 0.54px;
  }
  .blocking-window__contact-form .contact-form__info-text {
    margin-bottom: 36px;
  }
  .blocking-window__contact-form .contact-form__content {
    gap: 28px;
  }
}
@media only screen and (min-device-width: 992px) {
  .blocking-container {
    max-width: 1012px;
  }
  .blocking-window__contact-form {
    padding: 25px 36px 36px 36px;
  }
  .blocking-window__contact-form .contact-form__container-header {
    font-size: 40px;
    letter-spacing: 1.6px;
  }
  .blocking-window__contact-form .contact-form__info-text {
    font-size: 20px;
    letter-spacing: 0.6px;
  }
  .blocking-window__contact-form .contact-form__info-text {
    margin-bottom: 36px;
  }
  .blocking-window__contact-form .contact-form__content {
    column-gap: 36px;
    row-gap: 20px;
  }
}
@media only screen and (min-device-width: 1366px) {
  .blocking-container {
    max-width: 1156px;
  }
  .blocking-window__contact-form {
    padding: 25px 36px 36px 36px;
  }
  .blocking-window__contact-form .contact-form__info-text {
    font-size: 24px;
    letter-spacing: 0.72px;
  }
  .blocking-window__contact-form .contact-form__container-header {
    font-size: 44px;
    letter-spacing: 1.76px;
  }
  .blocking-window__contact-form .contact-form__info-text {
    margin-bottom: 36px;
  }
  .blocking-window__contact-form .contact-form__content {
    column-gap: 36px;
    row-gap: 32px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BlockingWindow/contactUsWindow/contactUsWindow.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,0CAAA;EACA,kCAAA;AACF;AACE;EACE,wCAAA;AACJ;;AAGA;EACE;IACE,6BAAA;EAAF;EAEA;IACE,aAAA;EAAF;EAEE;IACE,eAAA;IACA,sBAAA;EAAJ;EAGE;IACE,eAAA;IACA,sBAAA;EADJ;EAIE;IACE,mBAAA;EAFJ;EAKE;IACE,SAAA;EAHJ;AACF;AAOA;EACE;IACE,gBAAA;EALF;EAOA;IACE,4BAAA;EALF;EAOE;IACE,eAAA;IACA,sBAAA;EALJ;EAQE;IACE,eAAA;IACA,sBAAA;EANJ;EASE;IACE,mBAAA;EAPJ;EAUE;IACE,SAAA;EARJ;AACF;AAYA;EACE;IACE,iBAAA;EAVF;EAYA;IACE,4BAAA;EAVF;EAYE;IACE,eAAA;IACA,qBAAA;EAVJ;EAaE;IACE,eAAA;IACA,qBAAA;EAXJ;EAcE;IACE,mBAAA;EAZJ;EAeE;IACE,gBAAA;IACA,aAAA;EAbJ;AACF;AAiBA;EACE;IACE,iBAAA;EAfF;EAiBA;IACE,4BAAA;EAfF;EAiBE;IACE,eAAA;IACA,sBAAA;EAfJ;EAkBE;IACE,eAAA;IACA,sBAAA;EAhBJ;EAmBE;IACE,mBAAA;EAjBJ;EAoBE;IACE,gBAAA;IACA,aAAA;EAlBJ;AACF","sourcesContent":[".blocking-window__contact-form {\n  border-radius: 8px;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.04);\n  background: var(--secondary-color);\n\n  .contact-form__container {\n    background-color: var(--secondary-color);\n  }\n}\n\n@media only screen and (min-device-width: 320px) {\n  .blocking-container {\n    max-width: calc(100vw - 8.8%);\n  }\n  .blocking-window__contact-form {\n    padding: 16px;\n\n    .contact-form__container-header {\n      font-size: 24px;\n      letter-spacing: 0.96px;\n    }\n\n    .contact-form__info-text {\n      font-size: 16px;\n      letter-spacing: 0.48px;\n    }\n\n    .contact-form__info-text {\n      margin-bottom: 20px;\n    }\n\n    .contact-form__content {\n      gap: 12px;\n    }\n  }\n}\n\n@media only screen and (min-device-width: 768px) {\n  .blocking-container {\n    max-width: 552px;\n  }\n  .blocking-window__contact-form {\n    padding: 25px 36px 36px 36px;\n\n    .contact-form__container-header {\n      font-size: 32px;\n      letter-spacing: 1.28px;\n    }\n\n    .contact-form__info-text {\n      font-size: 18px;\n      letter-spacing: 0.54px;\n    }\n\n    .contact-form__info-text {\n      margin-bottom: 36px;\n    }\n\n    .contact-form__content {\n      gap: 28px;\n    }\n  }\n}\n\n@media only screen and (min-device-width: 992px) {\n  .blocking-container {\n    max-width: 1012px;\n  }\n  .blocking-window__contact-form {\n    padding: 25px 36px 36px 36px;\n\n    .contact-form__container-header {\n      font-size: 40px;\n      letter-spacing: 1.6px;\n    }\n\n    .contact-form__info-text {\n      font-size: 20px;\n      letter-spacing: 0.6px;\n    }\n\n    .contact-form__info-text {\n      margin-bottom: 36px;\n    }\n\n    .contact-form__content {\n      column-gap: 36px;\n      row-gap: 20px;\n    }\n  }\n}\n\n@media only screen and (min-device-width: 1366px) {\n  .blocking-container {\n    max-width: 1156px;\n  }\n  .blocking-window__contact-form {\n    padding: 25px 36px 36px 36px;\n\n    .contact-form__info-text {\n      font-size: 24px;\n      letter-spacing: 0.72px;\n    }\n\n    .contact-form__container-header {\n      font-size: 44px;\n      letter-spacing: 1.76px;\n    }\n\n    .contact-form__info-text {\n      margin-bottom: 36px;\n    }\n\n    .contact-form__content {\n      column-gap: 36px;\n      row-gap: 32px;\n    }\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
